var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import GroundingMarker from './grounding-marker.vue';
import StepsCollapsible from './steps-collapsible.vue';
import ChartBlock from './chart-block.vue';
import MermaidBlock from './mermaid-block.vue';
import MapBlock from './map-block.vue';
import ArtifactBlock from './artifact-block.vue';
import DeepSteps from './deep-steps.vue';
import { renderMessageSegments } from '../streaming-markdown';
var MessageBubble = /** @class */ (function (_super) {
    __extends(MessageBubble, _super);
    function MessageBubble() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.copyState = '';
        _this.copyIconClass = 'fas fa-copy';
        _this.ratingFormOpen = false;
        _this.ratingPending = null;
        _this.ratingComment = '';
        _this.ratingSubmitting = false;
        _this.lockedRating = null;
        return _this;
    }
    MessageBubble.prototype.created = function () {
        this.lockedRating = this.message.rating || null;
    };
    Object.defineProperty(MessageBubble.prototype, "isUser", {
        get: function () {
            return this.message.role === 'user';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "showDeepSteps", {
        // A deep answer's investigation steps are always shown: they are how the answer was made.
        get: function () {
            return !this.isUser && !!this.message.deep && !!(this.message.deep_steps && this.message.deep_steps.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "showSteps", {
        get: function () {
            return this.showMidSteps && !this.isUser && !!(this.message.steps && this.message.steps.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "showGroundingMarker", {
        // The other two grounding cases, shown in the slot the steps chip would occupy.
        // Gated on the same setting as the chip: both answer "how was this produced?".
        // Older messages, saved before grounding was recorded, have no marker rather than
        // a guessed one.
        get: function () {
            if (!this.showMidSteps || this.isUser || this.streaming)
                return false;
            return this.message.grounding === 'context' || this.message.grounding === 'none';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "renderedSegments", {
        get: function () {
            return renderMessageSegments(this.message.content, this.streaming);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "hasArtifacts", {
        // A deep answer showing a table or chart takes the full width rather than shrinking to its
        // text: the chart sizes itself to the bubble, so a narrow bubble squeezes the chart.
        get: function () {
            return this.renderedSegments.some(function (segment) { return segment.kind === 'artifact'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "relativeTime", {
        get: function () {
            this.clock; // eslint-disable-line no-unused-expressions
            if (!this.message.asked_at)
                return '';
            return moment(this.message.asked_at).fromNow();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "locked", {
        get: function () {
            return this.lockedRating !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessageBubble.prototype, "visualRating", {
        get: function () {
            return this.locked ? this.lockedRating : this.ratingPending;
        },
        enumerable: false,
        configurable: true
    });
    MessageBubble.prototype.copy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clipboard, html, item, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clipboard = navigator.clipboard;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!(this.isUser || !window.ClipboardItem)) return [3 /*break*/, 3];
                        return [4 /*yield*/, clipboard.writeText(this.message.content)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        html = marked.parse(this.message.content);
                        item = new window.ClipboardItem({
                            'text/plain': new Blob([this.message.content], { type: 'text/plain' }),
                            'text/html': new Blob([html], { type: 'text/html' }),
                        });
                        return [4 /*yield*/, clipboard.write([item])];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.showCopyFeedback(true);
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this.showCopyFeedback(false);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MessageBubble.prototype.showCopyFeedback = function (success) {
        var _this = this;
        this.copyIconClass = success ? 'fas fa-check' : 'fas fa-times';
        this.copyState = success ? 'copy-success' : 'copy-fail';
        setTimeout(function () {
            _this.copyIconClass = 'fas fa-copy';
            _this.copyState = '';
        }, 1500);
    };
    MessageBubble.prototype.openRatingForm = function (rating) {
        var _this = this;
        if (this.locked)
            return;
        this.ratingPending = rating;
        this.ratingFormOpen = true;
        document.addEventListener('click', this.handleOutsideClick);
        this.$nextTick(function () {
            var form = _this.$refs.ratingForm;
            var textarea = form ? form.querySelector('textarea') : null;
            if (textarea)
                textarea.focus();
        });
    };
    MessageBubble.prototype.cancelRatingForm = function () {
        this.ratingPending = null;
        this.ratingComment = '';
        this.ratingFormOpen = false;
        document.removeEventListener('click', this.handleOutsideClick);
    };
    MessageBubble.prototype.handleOutsideClick = function (e) {
        var form = this.$refs.ratingForm;
        if (form && form.contains(e.target))
            return;
        this.cancelRatingForm();
    };
    MessageBubble.prototype.submitRating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, resp, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.ratingPending || this.ratingSubmitting)
                            return [2 /*return*/];
                        this.ratingSubmitting = true;
                        url = this.rateUrlTemplate.replace('/0/rate/', "/".concat(this.message.chat_log_id, "/rate/"));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': this.$getCsrfToken() },
                                body: JSON.stringify({ rating: this.ratingPending, comment: this.ratingComment.trim() }),
                            })];
                    case 2:
                        resp = _a.sent();
                        if (!resp.ok)
                            throw new Error('rate failed');
                        this.lockedRating = this.ratingPending;
                        this.ratingFormOpen = false;
                        document.removeEventListener('click', this.handleOutsideClick);
                        this.$emit('rated', this.lockedRating);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.ratingSubmitting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MessageBubble.prototype.beforeDestroy = function () {
        document.removeEventListener('click', this.handleOutsideClick);
    };
    __decorate([
        Prop({ type: Object, required: true })
    ], MessageBubble.prototype, "message", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], MessageBubble.prototype, "showMidSteps", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], MessageBubble.prototype, "streaming", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], MessageBubble.prototype, "rateUrlTemplate", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], MessageBubble.prototype, "strings", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({ styleUrl: '', accessToken: '' }); } })
    ], MessageBubble.prototype, "mapConfig", void 0);
    __decorate([
        Prop({ type: Number, default: null })
    ], MessageBubble.prototype, "sessionId", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], MessageBubble.prototype, "artifactUrlTemplate", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], MessageBubble.prototype, "isLast", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], MessageBubble.prototype, "canApprove", void 0);
    __decorate([
        Prop({ type: Number, default: 0 })
    ], MessageBubble.prototype, "clock", void 0);
    MessageBubble = __decorate([
        Component({
            components: { GroundingMarker: GroundingMarker, StepsCollapsible: StepsCollapsible, ChartBlock: ChartBlock, MermaidBlock: MermaidBlock, MapBlock: MapBlock, ArtifactBlock: ArtifactBlock, DeepSteps: DeepSteps },
        })
    ], MessageBubble);
    return MessageBubble;
}(Vue));
export default MessageBubble;
